<template lang="html">
    <div>
        <div class="container container-small">
            <template v-if="device == 'desktop'">
                <div class="pt-3 import-info" v-if="showInfo">
                    <span class="mb-0">
                        Folosiți această pagină pentru a încarcă informațiile vehiculelor dvs. in cont.<br/>
                        <a href="/media/exemple.csv">Apasați aici</a> pentru a descărca fișierul model sau <a href="/media/coduri_tari.rar">apasați aici</a> pentru a descarcă pdf-ul pentru codurile țări.<br/>
                        Pentru a reuși importul, fișierul trebuie să respecte următoarele reguli:
                    </span>
                    <ul>
                        <li>Să fie fișier salvat în formatul csv (.csv)</li>
                        <li>
                            Să conțină 5 coloane:
                            <ul>
                                <li>Numărul de înmatriculare (fără spații sau alte caractere, ex: AG01DAB)</li>
                                <li>Seria de șasiu</li>
                                <li>Categorie rovinietă</li>
                                <li>Categorie taxă pod fetești</li>
                                <li>Cod tară</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="action-button">
                    <button class="mt-3 d-block main-btn w-100" @click="showInfo = !showInfo">
                        <span class="fas fa-long-arrow-alt-up" v-if="showInfo"></span>
                        <span class="fas fa-long-arrow-alt-down" v-if="!showInfo"></span>
                        {{showInfo ? $t('btn_show_less_info') : $t('btn_show_more_info') }}
                    </button>
                </div>
                <div class="text-center mt-3" :class="{'text-success': imported && count, 'text-danger': imported && !count}" v-if="imported">
                    {{ $tc('imported_vehicles', count, { vehicles: count }) }}
                </div>
            </template>
            <div class="row imports">
                <template v-if="device == 'desktop'">
                    <div class="col action-button" :class="{'pr-1': vehicles && vehicles.length, 'pr-3': !(vehicles && vehicles.length)}">
                        <input type="file" class="d-none" ref="file" @change="importVehiclesCSV()">
                        <button class="d-block main-btn w-100" @click="$refs.file.click()">
                            <span class="fas fa-long-arrow-alt-up"></span>
                            {{ $t('btn_import_csv') }}
                        </button>
                    </div>
                    <div class="col action-button pr-md-1" v-if="vehicles && vehicles.length">
                        <button class="d-block main-btn w-100" @click="exportVehiclesCSV()">
                            <span class="fas fa-long-arrow-alt-down"></span>
                            {{ $t('btn_export_csv') }}
                        </button>
                    </div>
                </template>
                <div class="col-12 col-sm-12 col-md action-button" v-if="vehicles && vehicles.length">
                    <router-link :to="{name: 'add-car'}">
                        <button type="submit" class="main-btn w-100 mt-3 mt-md-0">
                            {{ $t('btn_add_car') }}
                            <i class="fas fa-plus mr-2"></i>
                        </button>
                    </router-link>
                </div>
            </div>
            <template>
                <div class="d-sm-flex">
                    <div class="d-flex search-car-number-wrapper">
                        <div class="form-group search-car-number">
                            <input type="text" class="form-control mb-3" v-model="carPlateFilter" @keypress.enter="loadVehicles" :placeholder=" $t('search_car_after_license_plate') ">
                        </div>
                        <button class="main-btn" @click="loadVehicles()">{{ $t('search_car_button') }}</button>
                    </div>
                    <div class="form-group pl-sm-3 mb-3 flex-sm-grow-1">
                        <select class="form-control" v-model="sortBy">
                            <option :value="null">{{ $t('sort_by') }}:</option>
                            <option :value="'vignette_expiry'">{{ $t('sort_vignette_expiry') }}</option>
                            <option :value="'car_plate_asc'">{{ $t('sort_by_car_name') }}</option>
                        </select>
                    </div>
                    <div class="form-group pl-sm-3 mb-3 flex-sm-grow-1">
                        <select class="form-control" v-model="filterByVignetteStatus">
                            <option :value="null">{{ $t('show_all_vehicles') }}</option>
                            <option :value="'active'">{{ $t('show_only_active_vignette_vehicles') }}</option>
                            <option :value="'expired'">{{ $t('show_only_expired_vignette_vehicles') }}</option>
                        </select>
                    </div>
                </div>
                <div class="cart-item remove-a" v-if="vehicles && vehicles.length" v-for="(item, key) in vehicles" v-bind:key="'vehicle-' + key">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-md-flex d-block mb-2 w-100 justify-content-between align-items-center">
                                <p class="fs-big">{{item._plateNo}}</p>
                                <p class="fs-medium">{{item.country.country}}</p>
                            </div>
                            <div class="d-md-flex d-block mb-2 w-100 justify-content-between align-items-center" v-if="item._chasisNo">
                                <div class="fs-size">{{ capitalize($t('label_chasis_number')) }}</div>
                                <div class="fs-medium">{{item._chasisNo}}</div>
                            </div>
                            <div class="d-md-flex d-block mb-2 w-100 justify-content-between align-items-center" v-if="item.category_vignette">
                                <div class="fs-size">{{ capitalize($t('category')) }} {{ $tc('vignetteWord', 1) }}</div>
                                <div class="fs-medium">{{item.category_vignette.title.replace('Categoria', '')}}</div>
                            </div>
                            <div class="d-md-flex d-block mb-2 w-100 justify-content-between align-items-center" v-if="item.category_toll">
                                <div class="fs-size">{{ capitalize($t('category')) }} {{ $tc('tollWord', 1) }}</div>
                                <div class="fs-medium">{{item.category_toll.title.replace('Categoria', '')}}</div>
                            </div>
                            <div class="d-md-flex d-block mb-2 w-100 justify-content-between align-items-center">
                                <div class="fs-size">{{$t('vignette_status')}}</div>
                                <div class="fs-medium" :class="{'text-success': item.vignette_active_status_count, 'text-danger': !item.vignette_active_status_count && item.vignette_all_time_status_count}">{{vignetteStatus(item)}}</div>
                            </div>
                            <div class="action-buttons">
                                <div class="d-block d-md-flex justify-content-between align-items-center">
                                    <div class="d-md-flex justify-content-between">
                                        <div v-if="item.category_vignette" class="mr-md-4 mb-3">
                                            <router-link :to="{ name: 'vignette-category', params: {id: item.category_vignette.id, carId: item.id}}" class="btn main-btn">
                                                <i class="fas fa-cart-plus"></i> {{$t('vignette_buy')}}
                                            </router-link>
                                        </div>
                                        <div v-else class="mr-md-4 mb-3">
                                            <router-link class="btn main-btn warning d-flex justify-content-center align-items-center" :to="{name: 'edit-car', params: {id: item.id}}">
                                                <span class="far fa-pencil-alt mr-2"></span> {{ $t('fill_in_erv_category') }}
                                            </router-link>
                                        </div>
                                        <div v-if="item._category_TPF" class="mr-md-4 mb-3">
                                            <router-link :to="{ name: 'toll-category', params: {id: item._category_TPF, carId: item.id}}" class="btn main-btn">
                                                <i class="fas fa-cart-plus"></i> {{$t('toll_buy')}}
                                            </router-link>
                                        </div>
                                        <div v-else class="mr-md-4 mb-3">
                                            <router-link class="btn main-btn warning d-flex justify-content-center align-items-center" :to="{name: 'edit-car', params: {id: item.id}}">
                                                <span class="far fa-pencil-alt mr-2"></span> {{ $t('fill_in_tpf_category') }}
                                            </router-link>
                                        </div>
                                        <div>
                                            <a @click.prevent="brokerNetService.goToBrokerNet()" class="btn main-btn d-flex justify-content-center align-items-center">
                                                {{ $t('insurance_buy') }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-start justify-sm-content-end align-items-center mt-sm-4 mt-2">
                                        <router-link :to="{name: 'edit-car', params: {id: item.id}}" class="edit-btn">
                                            <span class="edit-icon"></span>
                                        </router-link>
                                        <span class="trash-btn" v-on:click="remove(item.id)">
                                            <span class="delete-icon"></span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <Pagination :page="page" :total="vehicles_total" @goToPage="setPage"></Pagination>
            <div class="action-button text-center bottom-action-btn">
                <router-link :to="{name: 'add-car'}">
                    <button type="submit" class="main-btn">
                        {{ $t('btn_add_car') }}
                        <i class="fas fa-plus mr-2"></i>
                    </button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import axios from '../../plugins/axios';
    import Pagination from '../snippets/Pagination.vue';
    import { BrokerNetService } from '../../services/BrokerNetService';

    export default {
        name: 'MyVehicles',
        components: {
            Pagination
        },
        data: function() {
            return {
                vehicles: null,
                vehicles_total: 0,
                page: 1,
                loading: false,
                cadId: null,
                carPlateFilter: null,
                filterByVignetteStatus: null,
                sortBy: 'vignette_expiry',
                showInfo: false,
                count: 0,
                imported: false,
                device: process.env.VUE_APP_DEVICE,
                brokerNetService: null
            }
        },
        computed: {
            ...mapState('user', [
                'user'
            ]),
        },
        mounted() {
            this.loadVehicles();
            this.brokerNetService = new BrokerNetService();
        },
        watch: {
            filterByVignetteStatus() {
                this.loadVehicles();
            },
            sortBy() {
                this.loadVehicles();
            },
            carPlateFilter(nVal, oVal) {
                if(oVal.length && !nVal.length) {
                    this.loadVehicles();
                }
            }
        },
        methods: {
            ...mapActions('vehicles', {
                actionDeleteVehicle: 'deleteVehicle'
            }),

            vignetteStatus(item) {
                return item.vignette_active_status_count ? this.$t('active') + (item.vignette_active_status[0].date_stop_availability) : (item.vignette_all_time_status_count ? this.$t('expired') : this.$t('unknown'));
            },

            setPage(page) {
                this.page = page;

                this.loadVehicles();
            },

            async loadVehicles() {
                this.loading = true;

                let params = {};

                if(this.carPlateFilter) {
                    params.car_plate_number = this.carPlateFilter;
                }

                if(this.filterByVignetteStatus) {
                    params.vignette_status = this.filterByVignetteStatus;
                }

                if(this.sortBy == 'car_plate_asc') {
                    params.sort_car_plate_number = this.sortBy;
                }

                if(this.sortBy == 'vignette_expiry') {
                    params.sort_car_vignette_expiry_date = this.sortBy;
                }

                params.page = this.page;

                this.$store.dispatch('vehicles/getVehicles', params).then(response => {
                    this.vehicles = response.data.data.vehicles;
                    this.vehicles_total = response.data.data.vehicles_total;
                    this.loading = false;
                }, error => {
                    console.log(error);
                });
            },

            exportVehiclesCSV() {
                let data = [];
                axios.get('/vehicles/export').then(response => {
                    data = response.data.vehicles;

                    let csv = this.$t('csv_header') + '\n';
                    for(let k in data) {
                        csv += '"' + data[k].number + '","' + data[k].chasis.toString() + '","' + data[k].categoryVignette + '","' + data[k].categoryToll + '","' + data[k].country + '"';
                        csv += "\n";
                    }

                    let anchor = document.createElement('a');
                    anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                    anchor.target = '_blank';
                    anchor.download = 'vehicles.csv';
                    anchor.click();
                });
            },

            importVehiclesCSV() {
                var formData = new FormData();
                var imagefile = this.$refs.file;
                formData.append("file", imagefile.files[0]);

                this.$refs.file.value = '';

                axios.post('/vehicles/import', formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    this.count = response.data.status;
                    this.imported = true;
                    setTimeout(() => {
                        this.imported = false;
                    }, 10000);
                    this.loadVehicles();
                }).catch(error => {
                    this.$dialog.alert({
                        'message': error.response.data.error.error_msg,
                        'confirmButtonText': this.$t('btn_i_understand')
                    });
                });
            },

            remove(id) {
                this.carId = id;

                this.$dialog.confirm({
                    title: this.$t('edit_car_delete_vehicle_title'),
                    message: this.$t('edit_car_delete_vehicle'),
                    cancelButtonText: this.$t('no'),
                    confirmButtonText: this.$t('yes'),
                    beforeClose: this.doRemoveVehicle
                })
                .then(() => {
                    this.$router.push({ name: 'my-cars' });
                })
                .catch(() => {
                    // on cancel
                });
            },

            doRemoveVehicle(action, done) {
                if(action == 'confirm') {
                    this.actionDeleteVehicle(this.carId).then(async response => {
                        await this.loadVehicles();
                        done();
                    }).catch(err => {
                        if(err.response) {
                            this.$dialog.alert({
                                'message': err.response.data.error.error_msg,
                                'confirmButtonText': this.$t('btn_i_understand')
                            });
                        }
                        done();
                    });
                }
                else {
                    done();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

$lightgrey: lightgrey;
$green: #59af54;
$grey: #EEEDEC;

.imports {
    margin-bottom: 15px;
    margin-top: 15px;

    @media only screen and (max-width: 768px) {
        margin-bottom: 18px;
    }
}

.main-btn {
    font-size: 15px;
    padding: 8px 18px;
}

.cart-item {
     border-radius: 5px;
     font-size: 14px;
     white-space:nowrap;
     position: relative;
     background: $grey;
     padding: 21px 24px;
     margin-bottom: 30px;

     .fs-big {
         font-size: 22px;
         font-weight: bold;
         margin: 0px;
     }

     .fs-medium {
         font-weight: bold;
         margin: 0px;
     }

     .fs-small {
         margin: 0px;
     }
}

.bottom-action-btn {
    padding-bottom: 61px;
    padding-top: 11px;

    @media only screen and (min-width: 768px) {
        max-width: 220px;
        margin: 0 auto;

        .main-btn {
            padding: 13.5px 13px;
            font-size: 18px;
        }
    }

}

.plus-btn {
    font-size: 18px;
    cursor: pointer;

    @media only screen and (min-width: 768px) {
        margin-right: 35px;
    }
}

.edit-btn {
    font-size: 18px;

    @media only screen and (min-width: 768px) {
        margin-right: 35px;
    }

    @media only screen and (max-width: 768px) {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #FAF9F6;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
    }
}

.trash-btn {
    font-size: 18px;
    cursor: pointer;

    @media only screen and (max-width: 768px) {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #FAF9F6;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.search-car-number-wrapper {

    .search-car-number {

        @media only screen and (max-width: 768px) {
            max-width: 400px;
        }

        @media only screen and (min-width: 769px) {
            max-width: 175px;
        }

        input {
            width: 100%;
        }
    }

    .main-btn {
        max-width: 100px;
        margin-left: 20px;
        height: 50px;

        @media only screen and (max-width: 768px) {
            max-width: 150px;
        }
    }
}

.import-info {

    ul {
        font-size: 16px;

        ul {
            padding-left: 20px;
            list-style: inside;
        }
    }
}

</style>
